import { useEffect, useMemo, useState } from "react";
import { IDENTIFIER } from "../../components/FormGenerator/constants";
import FormGenerator from "../../components/FormGenerator";
import { useToastrContext } from "../../components/Provider/ToastrProvider";
import { UPDATE_MSG } from "../../constant";
import { createInventory } from "./api";
import dayjs from "dayjs";
import { Card } from "react-bootstrap";

const BulkInventory = ({ hotelDetails, dateRange, contractType }) => {
  const [data, setData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { errorResponseHandler } = useToastrContext();

  useEffect(() => {
    if (!hotelDetails) return;
    setData(
      hotelDetails?.room?.map((row) => ({
        roomId: row?.id,
        available: 0,
        name: row?.roomName,
        taggedRatePlan: row?.taggedRatePlan.map((rate) => rate.ratePlanId)
      }))
    );
  }, [hotelDetails]);

  const formConfig = useMemo(() => {
    if (!data) {
      return {
        fields: [],
      };
    }

    return {
      fields: data?.map((row) => ({
        name: row.roomId.toString(),
        label: row?.name,
        type: IDENTIFIER.INPUTTEXT,
        validation: { required: `${row?.name} is required` },
        alignment: {
          sm: 12,
          md: 4,
          lg: 4,
        },
      })),
    };
  }, [data]);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const dataJson = data?.map((row) => {
        return row?.taggedRatePlan?.map((ratePlanId) => ({
          hotelId: hotelDetails.id,
          roomId: row?.roomId,
          ratePlanId: ratePlanId,
          available: formData[row.roomId],
        }));
      }).flat();

      const payload = {
        startDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
        endDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
        contractType,
        data: dataJson
      }

      const response = await createInventory(payload);

      if ([200, 201]?.includes(response?.status)) {
        errorResponseHandler(UPDATE_MSG, 'success');
      }
    } catch (error) {
      errorResponseHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <Card.Body className="form-body">
        <FormGenerator
          formConfig={{ ...formConfig }}
          onSubmit={handleSubmit}
          loading={isSubmitting}
          permissions={["rate:edit", "rate:create"]}
        />
      </Card.Body>
    </Card>
  );
};

export default BulkInventory;
